import { truncateLabel } from "../truncateLabel";
import type { GetRoomLabelText } from "./types";

// "Kitchen · 12.4 m²", or the name alone when no area is known.
export const getRoomLabelText: GetRoomLabelText = ({ name, areaM2 }) => {
  const label = truncateLabel(name);
  return areaM2 === null ? label : `${label} · ${areaM2.toFixed(1)} m²`;
};
